export default __webpack_public_path__ + "static/media/datadog_badge.69da582e.png";